/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("cs", i.count, {});
	if (countPlural == "one") return `Zobrazit produkt`;
	if (countPlural == "other") return `Zobrazit ${i.count} produktů`;
	return "see_products_with_filter";
};

const da_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("da", i.count, {});
	if (countPlural == "one") return `Se produktet`;
	if (countPlural == "other") return `Se ${i.count} produkter`;
	return "see_products_with_filter";
};

const de_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	if (countPlural == "one") return `Produkt ansehen`;
	if (countPlural == "other") return `${i.count} Produkte anzeigen`;
	return "see_products_with_filter";
};

const en_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	if (countPlural == "one") return `View product`;
	if (countPlural == "other") return `View ${i.count} products`;
	return "see_products_with_filter";
};

const es_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	if (countPlural == "one") return `Ver el producto`;
	if (countPlural == "other") return `Ver los ${i.count} productos`;
	return "see_products_with_filter";
};

const fr_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	if (countPlural == "one") return `Voir le produit`;
	if (countPlural == "other") return `Voir les ${i.count} produits`;
	return "see_products_with_filter";
};

const hu_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("hu", i.count, {});
	if (countPlural == "one") return `Termék megtekintése`;
	if (countPlural == "other") return `${i.count} termék megtekintése`;
	return "see_products_with_filter";
};

const it_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	if (countPlural == "one") return `Vedi il prodotto`;
	if (countPlural == "other") return `Vedi i ${i.count} prodotti`;
	return "see_products_with_filter";
};

const nl_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("nl", i.count, {});
	if (countPlural == "one") return `Bekijk het product`;
	if (countPlural == "other") return `Bekijk de ${i.count} producten`;
	return "see_products_with_filter";
};

const pl_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("pl", i.count, {});
	if (countPlural == "one") return `Zobacz produkt`;
	if (countPlural == "other") return `Zobacz ${i.count} produktów`;
	return "see_products_with_filter";
};

const pt_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("pt", i.count, {});
	if (countPlural == "one") return `Ver o produto`;
	if (countPlural == "other") return `Ver os ${i.count} produtos`;
	return "see_products_with_filter";
};

const sv_see_products_with_filter = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("sv", i.count, {});
	if (countPlural == "one") return `Se produkten`;
	if (countPlural == "other") return `Se ${i.count} produkter`;
	return "see_products_with_filter";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const see_products_with_filter = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.see_products_with_filter(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("see_products_with_filter", locale)
	if (locale === "cs") return cs_see_products_with_filter(inputs)
	if (locale === "da") return da_see_products_with_filter(inputs)
	if (locale === "de") return de_see_products_with_filter(inputs)
	if (locale === "en") return en_see_products_with_filter(inputs)
	if (locale === "es") return es_see_products_with_filter(inputs)
	if (locale === "fr") return fr_see_products_with_filter(inputs)
	if (locale === "hu") return hu_see_products_with_filter(inputs)
	if (locale === "it") return it_see_products_with_filter(inputs)
	if (locale === "nl") return nl_see_products_with_filter(inputs)
	if (locale === "pl") return pl_see_products_with_filter(inputs)
	if (locale === "pt") return pt_see_products_with_filter(inputs)
	return sv_see_products_with_filter(inputs)
};